import { dispatch_event } from './functions';

export function init_toggle_height(){
    
    if( !document.querySelector('.ff_toggle_height') ) return;

    const init = (Toggle_Height)=>{

        document.querySelectorAll('.ff_toggle_height').forEach(container=>{
        
            if( typeof container.ff_toggle_height !== 'undefined' ) return;

            const trigger = container.querySelector('.ff_toggle_height_trigger');
            const target = container.querySelector('.ff_toggle_height_target');
            if( !trigger || !target ) return;
            
            container.ff_toggle_height = new Toggle_Height({
                trigger,
                target,
            });
        })

        dispatch_event('toggle_height_init');
    }
    
    import('classes/Toggle_Height').then(res=>init(res.default));
}